<app-loader>
	@if (loader.completed) {
		<ul
			class="menu-list"
			(keydown)="onKeyup($event)"
		>
			@for (menuItem of menu; track menuItem) {
				<li
					class="menu-list__item"
					#menuItem
				>
					@if (menuItem.routAction) {
						<a
							class="button-text button-text--blacked menu-list__item-link"
							(click)="routeActionClick(menuItem); hideProductsMenu()"
							[routerLink]="menuItem.routAction | routeLinkByScreenMode"
							[queryParams]="menuItem.queryParams"
						>
							{{ menuItem.title }}
						</a>
					}
					@if (menuItem.hideAction) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="hideProduct()"
						>
							{{ menuItem.title }}
						</button>
					}
					@if (menuItem.deleteAction) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="deleteProduct()"
						>
							{{ menuItem.title }}
						</button>
					}
					@if (menuItem.showAction) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="showProduct()"
						>
							{{ menuItem.title }}
						</button>
					}
					@if (menuItem.altLink) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="generateAltLink()"
						>
							{{ menuItem.title }}
						</button>
					}
					@if (menuItem.renameAction) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="renameProduct()"
						>
							{{ menuItem.title }}
						</button>
					}
					@if (menuItem.onClick) {
						<button
							class="button-text button-text--blacked menu-list__item-link"
							type="button"
							(click)="menuItem.onClick()"
						>
							{{ menuItem.title }}
						</button>
					}
				</li>
			}
			@if (!menu.length) {
				<li
					class="menu-list__item"
					#menuItem
				>
					<span>Операции недоступны</span>
				</li>
			}
		</ul>
	}
</app-loader>
